<router-outlet></router-outlet>

<div class="app-loading-wrapper" [hidden]="appLoaded$|async">
  <div class="app-loading-content">
    <div class="app-loading-logo"></div>
    <div class="app-loading-bar-wrapper">
      <div class="app-loading-bar">
        <div class="app-loading-inner-bar app-loading-inner-bar-1">
        </div>
        <div class="app-loading-inner-bar app-loading-inner-bar-2">
        </div>
      </div>
    </div>
  </div>
</div>

<!--<toaster-container [toasterconfig]="toasterConfig"></toaster-container>-->
<ibp-blocking-overlay></ibp-blocking-overlay>
<ibp-confirm-dialog></ibp-confirm-dialog>
